export class Room {
  params = {
    Rooms: 1,
    Adults: 1,
    Children: [],
  };
}
